export const ACTIVITY_BLOCK_FETCH = 'activityblock/ACTIVITY_BLOCK_FETCH';
export const ACTIVITY_BLOCK_FETCHED = 'activityblock/ACTIVITY_BLOCK_FETCHED';
export const ACTIVITY_BLOCK_ERROR = 'activityblock/ACTIVITY_BLOCK_ERROR';
export const ACTIVITY_COOKIE = 'activityblock/ACTIVITY_BLOCK_COOKIE';
